import styled from 'styled-components';

import Picture from 'components/picture';
import { primitive } from 'styles/constants/primitives';

export const DoubleActionBtnWrapper = styled.div`
  display: flex;
  align-content: flex-end;
  margin-block-start: -${primitive.$spacing7};
  position: relative;
  ${Styles.desktop} {
    inset-block-start: 0;
    margin-block-start: ${primitive.$spacing9};
  }
`;

export const WhiteBGWrapper = styled.div`
  background: ${Styles.color.white};
  display: flex;
  padding: ${primitive.$spacing1};
  width: 100%;
  ${Styles.desktop} {
    width: unset;
  }
`;

export const Icon = styled(Picture)`
  width: 23px;
  height: 19px;
  border-radius: unset;
`;

export const LeftDesktopBtnWrapper = styled.div`
  margin-inline-start: ${primitive.$spacing5};
`;

export const BottomHeroButtonWrapper = styled.div`
  margin-block-start: 2rem;
  margin-block-end: 1rem;
  margin-inline: 0;
  display: flex;
  justify-content: center;
`;
